<homey-notification-dialog-content [title]="notification().lotteries.length > 1 ? multipleTitle() : singleTitle()" [closeButton]="closeButton()">
  @if (notification().lotteries.length > 1) {
    <span [innerHTML]="multipleDescription()"></span>
  } @else {
    <span [innerHTML]="singleDescription()"></span>
  }
  <homey-lottery-list [lotteries]="lotteries()" [limit]="{number: apartmentIds().length}" class="max-h-[240px] overflow-y-scroll block -mr-2">
    <ng-template [lotteryListItem]="lotteries()" let-lottery>
      <ng-container *ngTemplateOutlet="lotteryListItem(); context: { $implicit: lottery }"/>
    </ng-template>
  </homey-lottery-list>
</homey-notification-dialog-content>

